import request from './client';

export async function submitContactForm({ name, email, mobile, message }) {
  return request('/contact', {
    method: 'POST',
    body: JSON.stringify({ name, email, mobile, message }),
  });
}
